import { useState } from 'react';
import {
  NJButton, NJHeading, NJTab, NJTabs, NJText,
} from '@engie-group/fluid-design-system-react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import type { ConfigurationReviewTab } from './types';
import './configuration-wireframes.css';

/** Revue uniquement : aucun champ ni mutation métier avant confirmation du PO. */
export function ConfigurationWireframes() {
  const [opened, setOpened] = useState(false);
  const [tab, setTab] = useState<ConfigurationReviewTab>('perimeters');
  return (
    <PrototypeStudioLayout title="Plan navigation V3 - Revue">
      <div className="pnv2-review">
        <header className="pnv2-review-heading">
          <div>
            <NJHeading as="h1" scale="md">Configuration projet — revue de parcours</NJHeading>
            <NJText scale="sm">Basse fidélité · contenu et droits confirmés le 30/10 · aucune donnée modifiée</NJText>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <NJButton label="Revue plans de développement" href="?view=wireframes&review=plans" variant="secondary" />
            <NJButton label="Retour au prototype" href="?view=prototype" variant="secondary" />
          </div>
        </header>
        <section className="pnv2-review-options" aria-label="Hypothèse de contenu">
          <NJText as="strong">Décisions confirmées</NJText>
          <NJText scale="sm">
            Station météo et DJU dans « ratios de consommations ». Mêmes droits de configuration pour tous les profils.
          </NJText>
        </section>
        <div className="pnv2-review-steps" aria-label="Parcours proposé">
          <NJText>1. Ouvrir un projet</NJText>
          <NJText>2. Cliquer sur Configuration projet</NJText>
          <NJText>3. Consulter les deux onglets et revenir à la carte</NJText>
        </div>
        <div className="pnv2-review-frame">
          <aside className="pnv2-review-rail" aria-label="Rail simplifié de la référence">
            <NJText as="strong">Plan</NJText>
            <NJText scale="sm">Accueil</NJText>
            <NJText scale="sm">Carte</NJText>
            <div className="pnv2-review-block"><NJText scale="sm">Autres entrées V3 inchangées</NJText></div>
            <NJButton label="Configuration projet" variant="secondary" onClick={() => setOpened(true)} />
          </aside>
          {opened ? (
            <section className="pnv2-review-page" aria-label="Configuration projet pleine page">
              <header className="pnv2-review-heading">
                <NJHeading as="h2" scale="sm">Configuration projet</NJHeading>
                <NJButton label="Fermer la configuration" icon="close" variant="secondary" onClick={() => setOpened(false)} />
              </header>
              <NJTabs label="Configuration projet" activeTab={tab}
                onClickTabItem={(id) => setTab(id === 'ratios' ? 'ratios' : 'perimeters')}>
                <NJTab id="perimeters" label="Périmètres" ariaControls="review-perimeters">
                <div className="pnv2-review-body">
                  <NJHeading as="h3" scale="xs">Contenu proposé, repris du panneau V3</NJHeading>
                  <div className="pnv2-review-block"><NJText>Nom du projet</NJText></div>
                  <div className="pnv2-review-block">
                    <NJText>Type de périmètre · communes ou contour</NJText>
                    <NJText>Libellé du périmètre · bâtiments copiés · date de copie UrbanMap · propriétaire</NJText>
                  </div>
                  <NJText scale="sm">
                    Périmètre en lecture seule, comme dans la V3. Le nom est modifiable par tous les profils.
                  </NJText>
                </div>
                </NJTab>
                <NJTab id="ratios" label="ratios de consommations" ariaControls="review-ratios">
                <div className="pnv2-review-body">
                  <NJHeading as="h3" scale="xs">Regroupement proposé des paramètres V3</NJHeading>
                  <div className="pnv2-review-block"><NJText>Tableau des ratios par usage, période et poste</NJText></div>
                  <div className="pnv2-review-block"><NJText>Station météo et DJU de référence — champs V3</NJText></div>
                  <div className="pnv2-review-block"><NJText>Impacts sur les consommations du projet</NJText></div>
                  <NJText scale="sm">Validation, réinitialisation et enregistrement existants proposés, sans nouvelle règle de calcul.</NJText>
                </div>
                </NJTab>
              </NJTabs>
              <footer className="pnv2-review-heading">
                <NJText scale="sm">Mêmes droits pour tous · revue sans mutation</NJText>
                <NJButton label="Enregistrer — aperçu" disabled />
              </footer>
            </section>
          ) : (
            <section className="pnv2-review-map" aria-label="Carte et en-tête simplifiés de la V3">
              <div className="pnv2-review-block"><NJText>Projet ouvert — en-tête V3 inchangé</NJText></div>
              <NJHeading as="h2" scale="sm">Carte du projet</NJHeading>
              <NJText>Cliquer sur « Configuration projet » dans le rail.</NJText>
              <NJText scale="sm">Fond hors ligne conservé ; aucun token Mapbox ajouté.</NJText>
            </section>
          )}
        </div>
      </div>
    </PrototypeStudioLayout>
  );
}
